import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-clear-search-btn',
  templateUrl: './clear-search-btn.component.html',
  styleUrls: ['./clear-search-btn.component.scss']
})
export class ClearSearchBtnComponent implements OnInit {
  @Input() searching: boolean = false;

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent() {
    this.onClick.emit();
  }
}
